import { Injectable } from '@angular/core';

import { SiteTypeEnum } from 'src/app/shared/enums';
import { EngagementAbstractService } from '../engagement-abstract.service';
import { EngagementWhatsappService } from './engagement-whatsapp.service';
import { EngagementKakaotalkService } from './engagement-kakaotalk.service';

@Injectable({
  providedIn: 'root',
})
export class EngagementStrategiesService {
  strategiesMap: Map<SiteTypeEnum, EngagementAbstractService> = new Map();

  private all: EngagementAbstractService[];

  constructor(
    engagementWhatsappService: EngagementWhatsappService,
    engagementKakaotalkService: EngagementKakaotalkService
  ) {
    this.all = [engagementWhatsappService, engagementKakaotalkService];
    if (!this.strategiesMap.size) {
      this.all.forEach(strategy => this.strategiesMap.set(strategy.channelType, strategy));
    }
  }

  getStrategy(strategy: SiteTypeEnum): EngagementAbstractService {
    return this.all.filter(s => s.channelType === strategy).pop();
  }
}
